var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"editorStyle",attrs:{"id":"editor"}}),_c('div',{staticClass:"bottomBtn"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goback}},[_vm._v("返回")]),_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.confirm}},[_vm._v("确认")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }